import { createStore } from 'vuex'

export const store = createStore({
  state: {
    currentParticipantSk: null,
    // Product
    // // Matching Page
    currentProductMismatchesSks: [],
    currentProductSk: null,
    // Master data selections
    selectedProductSks: [],
    selectedBrandSks: [],
    selectedLineSks: [],
    selectedCategorySks: [],
    selectedBenefitSks: [],
    selectedMultiPackSks: [],
    selectedCompanySks: [],
    selectedHouseSks: [],
    // Version counter to signal product matching mutations occurred (triggers expansion collapse)
    productMatchingMutationVersion: 0,
    // // // Review page
    // currentProductMatchingGroupSk: null,
    // currentProductMatchingsSks: [],
    // currentFilterByProductSk: null,
    // UI settings
    fixedHeader: true,
    errors: [],
    success: null,
    // Data selection configuration
    selectionConfig: {
      rowId: 1,              // 1=None/All, 2=Participant/All, 3=Participant/Both, 4=Brand/Both, 5=No Brand/Participant
      participantSk: null,
      brandSks: [],          // Array for multi-select (replaces brandSk)
      noBrand: false,        // Flag for row 5 (No Brand selection)
      isLocked: false
    }
  },
  mutations: {
    setSelection: (state, { selectionStateName, value }) => {
      state[selectionStateName] = value
      if (selectionStateName === 'currentProductMatchingSk') {
        state.currentProductMatchingsSks = []
      // } else if (selectionStateName === 'currentGeoMatchingGroupSk') {
      //   state.currentGeoMatchingsSks = []
      }
    },
    addToMultiSelection: (state, { selectionStateName, value }) => {
      state[selectionStateName].push(value)
    },
    removeFromMultiSelection: (state, { selectionStateName, value }) => {
      state[selectionStateName].splice(state[selectionStateName].indexOf(value), 1)
    },
    resetMultiSelection: (state, { selectionStateName }) => {
      state[selectionStateName] = []
    },
    setCurrentParticipantSk: (state, payload) => {
      state.currentProductMismatchesSks = []
      state.currentProductSk = null
      state.currentParticipantSk = payload
    },
    // Product
    resetCurrentProductMismatchesSks: (state) => {
      state.currentProductMismatchesSks = []
    },
    setCurrentProductMismatchesSks: (state, payload) => {
      state.currentProductMismatchesSks = payload
    },
    setCurrentProductSk: (state, payload) => {
      state.currentProductSk = payload
    },
    // common
    addError: (state, payload) => {
      if (!state.errors.includes(payload)) {
        state.errors.push(payload)
      }
    },
    resetErrors: (state) => {
      state.errors = []
    },
    addSuccess: (state, payload) => {
      state.success = payload
    },
    resetSuccess: (state) => {
      state.success = null
    },
    setFixedHeader: (state, payload) => {
      state.fixedHeader = payload
    },
    setSelectionConfig: (state, config) => {
      state.selectionConfig = { ...state.selectionConfig, ...config }
    },
    lockSelection: (state) => {
      state.selectionConfig.isLocked = true
    },
    addBrandToSelection: (state, brandSk) => {
      if (!state.selectionConfig.brandSks.includes(brandSk)) {
        state.selectionConfig.brandSks.push(brandSk)
      }
    },
    removeBrandFromSelection: (state, brandSk) => {
      const idx = state.selectionConfig.brandSks.indexOf(brandSk)
      if (idx > -1) {
        state.selectionConfig.brandSks.splice(idx, 1)
      }
    },
    clearBrandSelection: (state) => {
      state.selectionConfig.brandSks = []
      state.selectionConfig.noBrand = false
    },
    incrementProductMatchingMutationVersion: (state) => {
      state.productMatchingMutationVersion++
    }
  },
  actions: {

  }
})
